import { signInWithCustomToken } from 'firebase/auth';
import apiClient from './apiClient';
import { firebaseAuth } from './firebaseStorageConfig';

export const syncFirebaseAuth = async () => {
    try {
        const response = await apiClient.post(
            `${process.env.REACT_APP_ROOT_URL}/auth/firebase-token`
        );
        const customToken = response.data?.token;
        if (customToken) {
            await signInWithCustomToken(firebaseAuth, customToken);
        }
    } catch (error) {
        console.error('Firebase auth sync failed:', error.message);
    }
};
